import { Auth } from 'aws-amplify';

import { parsePaymentMethod } from 'services/paymentMethodsServices';

import { axios, axiosWithToken } from './axios';

export const fetchAddPaymentMethod = async (data) => {
  const user = await Auth.currentAuthenticatedUser();
  const authToken = user.signInUserSession.accessToken.jwtToken;

  const response = await axiosWithToken.post('payment', {
    authToken,
    biller: '2',
    ...data,
  });
  const paymentMethod = JSON.parse(response.data.body).billing_info;

  return parsePaymentMethod(paymentMethod);
};

export const fetchEditPaymentMethod = async (data) => {
  const user = await Auth.currentAuthenticatedUser();
  const authToken = user.signInUserSession.accessToken.jwtToken;

  await axiosWithToken.post('payment', {
    authToken,
    biller: '2',
    ...data,
  });
};

export const fetchGetPaymentMethods = async () => {
  const response = await axiosWithToken.get('payment');
  const paymentMethods = JSON.parse(response.data.body).billingInfo;

  return paymentMethods.map((card) => parsePaymentMethod(card));
};

export const fetchGetOutstandingBalance = async ({ campaignId }) => {
  const response = await axios.get('campaign/outstanding-balance', {
    params: {
      campaign_id: campaignId,
    },
  });

  const outstandingBalance = JSON.parse(response.data.body).outstanding_balance;
  const companyName = JSON.parse(response.data.body).name;
  const totalImpressions = JSON.parse(response.data.body)?.total_impressions;

  return { outstandingBalance, companyName, totalImpressions };
};

export const fetchSendStripePayment = async (data) => {
  const response = await axios.post('/payment/payment-link', data);

  console.log(response, 'response');
};

export const simpleStripePayment = async (data) => {
  const response = await axios.post('/payment/simple', data);

  console.log(response, 'response');
};

export const fetchSendCancelEvergreenRequest = async (data) => {
  await axiosWithToken.post('/campaign/cancel-billing/evergreen', data);
};
